import * as Sentry from "@sentry/vue";
import Vue from 'vue';
import Debug from 'debug';
import {AppSettings} from '@/application/AppSettings';

const log = Debug("sentry.ts")

export function initSentry(isDev: boolean, store: any) {
  if (!isDev) {
    Sentry.init({
      Vue: Vue,
      dsn: 'https://bf4a02aea53b4689964f30f4da54f3c2@o235837.ingest.sentry.io/5200925',
      release: AppSettings.APP_VERSION,
      beforeSend(event: any) { //https://docs.sentry.io/platforms/javascript/#filter-events--custom-logic
        event.extra = {'currentGame': store.getters.currentGame};
        return event;
      }
    });
    log('Sentry initialized')
  } else {
    log('Sentry disabled for dev')
  }
}

export function setSentryUser(uid: string, displayName: string) {
  Sentry.setUser({
    id: uid,
    username: displayName
  });
}

export function removeSentryUser() {
  Sentry.setUser(null);
}
